import Phaser from "phaser";
import { AssetKeys } from "../assets";
import { GAME_HEIGHT, GHOST_FRONT_LINE } from "../constants";
import type { WorldLifeSystem } from "./WorldLifeSystem";
import { WORLD_LIFE_CONFIG } from "../worldLifeConfig";
import { PlayerController } from "./PlayerController";

const FORMATION = [
  { x: 94, y: 1272, scale: 0.86, key: AssetKeys.ghost[5] },
  { x: 206, y: 1246, scale: 0.9, key: AssetKeys.ghost[1] },
  { x: 318, y: 1266, scale: 0.94, key: AssetKeys.ghost[0] },
  { x: 428, y: 1248, scale: 0.9, key: AssetKeys.ghost[4] },
  { x: 540, y: 1270, scale: 0.9, key: AssetKeys.ghost[2] },
  { x: 650, y: 1320, scale: 1.08, key: AssetKeys.ghost[3] },
  { x: 360, y: 1360, scale: 1.08, key: AssetKeys.ghost[6] }
];

export class GhostWallSystem {
  private ghosts: Array<{
    container: Phaser.GameObjects.Container;
    sprite: Phaser.GameObjects.Image;
    aura: Phaser.GameObjects.Image;
    trail: Phaser.GameObjects.Image;
    eyes: Phaser.GameObjects.Graphics;
    baseX: number;
    baseY: number;
  }> = [];

  constructor(private scene: Phaser.Scene, layer: Phaser.GameObjects.Layer) {
    FORMATION.forEach((ghost, index) => {
      const trail = scene.add.image(0, 38, AssetKeys.vfx.ghostTrail).setDisplaySize(160 * ghost.scale, 130 * ghost.scale).setAlpha(0.12);
      const aura = scene.add.image(0, 4, AssetKeys.vfx.ghostAura).setDisplaySize(118 * ghost.scale, 118 * ghost.scale).setAlpha(0.1);
      const sprite = scene.add.image(0, 0, ghost.key).setDisplaySize(142 * ghost.scale, 158 * ghost.scale).setAlpha(0.86).setTint(0x0f1710);
      const eyes = scene.add.graphics();
      const container = scene.add.container(ghost.x, ghost.y, [trail, aura, sprite, eyes]);
      layer.add(container);
      this.ghosts.push({ container, sprite, aura, trail, eyes, baseX: ghost.x, baseY: ghost.y });
      this.drawEyes(index, 0);
    });
  }

  update(elapsed: number, intensity: number, worldLife?: WorldLifeSystem) {
    this.ghosts.forEach((ghost, index) => {
      ghost.container.x = ghost.baseX + Math.sin(elapsed * 1.6 + index) * (4 + intensity * 3);
      ghost.container.y = ghost.baseY + Math.sin(elapsed * 1.2 + index * 0.7) * 6;
      ghost.container.alpha = 0.86 + intensity * 0.08;
      worldLife?.applyGhostLife(ghost, index, elapsed, intensity);
      this.drawEyes(index, elapsed);
    });
  }

  isCaught(player: PlayerController, pressure: number) {
    return pressure > 0.72 && player.hitboxCenterY + player.hitboxHeight * 0.5 > GHOST_FRONT_LINE;
  }

  private drawEyes(index: number, elapsed: number) {
    const ghost = this.ghosts[index];
    const pulse = 1 + Math.sin(elapsed * 2.1 + index) * WORLD_LIFE_CONFIG.ghostEyePulse;
    ghost.eyes.clear();
    ghost.eyes.fillStyle(0xb7ff00, 0.9);
    ghost.eyes.fillCircle(-12, -18, 4 * pulse);
    ghost.eyes.fillCircle(12, -18, 4 * pulse);
    ghost.eyes.fillStyle(0xdfff2f, 0.55);
    ghost.eyes.fillCircle(-12, -18, 8 * pulse);
    ghost.eyes.fillCircle(12, -18, 8 * pulse);
  }
}
